import { useParams } from "react-router-dom";
import Box from '@mui/material/Box';
import NIHLogo from "assets/images/logos/nci_logo_4.png";
import CellWithAxis from "assets/images/illustrations/cell_positive3-2.png"

const pressData = {
  "msk-partner-2024-01-23": {
    title:
      "Astrin Biosciences and Leading New York Cancer Center Announce New Cancer Research Collaboration",
    location: "New York, NY",
    date: "January 23, 2024",
    content: [
      {verbiage:`In a significant advancement for cancer research and treatment, Astrin Biosciences, a leader in AI-empowered 3D holographic technology for cancer cell detection, has announced a comprehensive research collaboration with Memorial Sloan Kettering Cancer Center (MSK). This collaboration will leverage the combined strengths of both organizations, with the goal of transforming biomarker development and its role in cancer research and treatment.`},
      {verbiage:`The collaboration sets the stage for an integrated approach, enabling researchers from Astrin and MSK to work together on a wide range of projects across the spectrum of cancer care. The collaboration is fueled by a shared commitment to eradicate the global scourge of cancer.<br/> <br/> Astrin's Founder and CEO, Jayant Parthasarathy, PhD, expressed his gratitude and optimism, "We are deeply honored to collaborate with MSK. Their trust in our platform is a testament to our technology's potential. Together, we have a remarkable opportunity to make a significant impact on the lives of those affected by cancer."`, image:CellWithAxis},
      {verbiage:`"This collaboration holds immense promise for advancing our understanding of cancer, from early detection to addressing the challenges of treatment resistance and disease complexity," said Howard I. Scher, MD, FASCO, Head of MSK's Biomarker Program and a world-renowned expert in cancer diagnostics.`},
      {verbiage:`The collaboration promises to accelerate the development of innovative cancer diagnostics and treatments. It underscores the commitment of both Astrin Biosciences and MSK to lead the charge in the global fight against cancer.`},
      {verbiage:`For more information about this collaboration, please contact: pr@astrinbio.com`}
    ],
    footer: {
      title: "About Astrin Biosciences",
      content: [
        `Astrin Biosciences is at the forefront of cancer research, revolutionizing the field with its AI-empowered 3D holographic imaging technology for detecting cancer cells. The company is dedicated to harnessing the power of technology to accelerate early detection and advance cancer care (https://astrinbio.com). `,
      ],
    },
  },
};

export default function PressPage() {
  const { id } = useParams();
  const article = pressData[id];
  
  const gridContainerStyle = {
    display: "grid",
    gridTemplateColumns: '1fr 1fr',
    '@media (max-width: 780px)': {
      display: "block",
      gridTemplateColumns: 'unset',
    }
  }

  const imageStyle = {
    height: '22em',
    m: '0 0 0 6em',
    '@media (max-width: 780px)': {
      height: '17em',
      m: '1em 0 0 0',
    }
  }


  return (
    <>
      {article && (
        <>
          <h1>
            <strong>{article.title}</strong>
          </h1>
          {article.content.map((paragraphSection, index) => {
            const sectionText = Array.isArray(paragraphSection)
              ? paragraphSection
              : [paragraphSection];
            return (
              <p>
                {sectionText.map((paragraph, sectionIndex) => (
                  <>
                    {index === 0 && sectionIndex === 0 && (
                      <strong>
                        {article.location} - {article.date}{" "}
                      </strong>
                    )}
                    { paragraph.image ?
                      <Box sx={gridContainerStyle}>
                        <Box dangerouslySetInnerHTML={{__html: paragraph.verbiage}} />
                        <Box component='img' sx={imageStyle} src={paragraph.image} alt={paragraph.image} /> 
                      </Box>
                      :
                      <Box>{paragraph.verbiage}</Box>
                    }
                    {sectionIndex < sectionText.length - 1 && <br />}
                  </>
                ))}
              </p>
            );
          })}
          {article.footer && (
            <>
              <h2 style={{ marginBottom: 0 }}>
                <strong>{article.footer.title}</strong>
              </h2>
              {article.footer.content.map((paragraph,dex) => (
                  <p sx={{ m: '2px 0 0 0' }}>{paragraph}</p>
              ))}
            </>
          )}
        </>
      )}
    </>
  );
}
